import React, { Component } from 'react';
import classes from './Scratcher.module.scss';
import scratch from './Scratching2.mp3';
import Confetti from 'react-confetti'

class Scratcher extends Component {

    constructor(props) {
        super(props);
        this.isScratching = false;
        this.lastPoint = null;
        this.isLoading = true;
        let height = props.height;
        let width = props.width
        let elementId = "audioElement" + new Date().valueOf().toString();
        this.elementId = elementId;
        let audioElement = document.createElement('audio');
        audioElement.src = scratch;
        audioElement.setAttribute("id", elementId);
        document.body.appendChild(audioElement);
        this.state = {
            visible: true,
            colors: 
             ['#f44336'
                ,'#e91e63'
                ,'#9c27b0'
                ,'#673ab7'
                ,'#3f51b5'
                ,'#2196f3'
                ,'#03a9f4'
                ,'#00bcd4'
                ,'#009688'
                ,'#4CAF50'
                ,'#8BC34A'
                ,'#CDDC39'
                ,'#FFEB3B'
                ,'#FFC107'
                ,'#FF9800'
                ,'#FF5722'
                ,'#795548'
            ],
            height: height,
            width: width,
        }
    }

    componentDidMount() {
        const canvas = this.canvas;
        canvas.width = canvas.parentElement.offsetWidth;
        canvas.height = canvas.parentElement.offsetHeight;
        canvas.addEventListener('mousedown', this.touchStart);
        canvas.addEventListener('touchstart', this.touchStart);
        canvas.addEventListener('mousemove', this.touchMove, { willReadFrequently: true});
        canvas.addEventListener('touchmove', this.touchMove, { willReadFrequently: true});
        canvas.addEventListener('mouseup', this.touchEnd);
        canvas.addEventListener('touchend', this.touchEnd);
        this.setOverlay(canvas);
    }


    setOverlay = (canvas) => {
        this.ctx = canvas.getContext('2d', {willReadFrequently: true});
        this.brush = new Image();
        this.brush.src = require('../../images/brush.png');
        this.cover = new Image();
        this.cover.src = this.props.overlay + '?' + new Date().getTime();
        this.cover.setAttribute('crossOrigin', '');
        this.brush.setAttribute('crossOrigin', '');
        this.brush.onload = () => {
            this.brush.setAttribute('crossOrigin', '');
        }
        this.cover.onload = () => {
            this.cover.setAttribute('crossOrigin', '');
            this.ctx.drawImage(this.cover, 0, 0, canvas.width, canvas.height);
            this.setState({
                height: canvas.height,
                widht: canvas.width
            })
            let rgb = this.getAverageRGB();
            let hex = this.rgbToHex(rgb.r, rgb.g, rgb.b);
            let newColors = [];
            for (let i = 0; i < 16; i++) {
                newColors.push(this.LightenDarkenColor(hex, i + 10))
            }
            if (newColors && newColors.length > 0) {
                this.setState({colors: newColors})
            }
            this.isLoading = false;
            this.props.onToggleLoading(false);
        }
    }

    componentWillUnmout() {
        const canvas = this.canvas;
        canvas.removeEventListener('mousedown', this.touchStart);
        canvas.removeEventListener('touchstart', this.touchStart);
        canvas.removeEventListener('mousemove', this.touchMove);
        canvas.removeEventListener('touchmove', this.touchMove);
        canvas.removeEventListener('mouseup', this.touchEnd);
        canvas.removeEventListener('touchend', this.touchEnd);
    }

    LightenDarkenColor = (col, amt) => {
        let usePound = false;
        if (col[0] === "#") {
            col = col.slice(1);
            usePound = true;
        }
        let num = parseInt(col,16);
        let r = (num >> 16) + amt;
        if (r > 255) {
            r = 255;
        } else if (r < 0) {
            r = 0;
        }
        let b = ((num >> 8) & 0x00FF) + amt;
        if (b > 255) {
            b = 255;
        } else if  (b < 0) {
            b = 0;
        }
        let g = (num & 0x0000FF) + amt;
        if (g > 255) {
            g = 255;
        } else if ( g < 0 ) {
            g = 0;
        }
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }

    getPosition = (event) => {
        let target = this.canvas;
        let offsetX = 0;
        let offsetY = 0;
        if (target.offsetParent !== undefined) {
            // eslint-disable-next-line 
            while (target = target.offsetParent) {
                offsetX += target.offsetLeft;
                offsetY += target.offsetTop;
            }
        }
        const x = (event?.pageX || event?.touches?.[0]?.clientX) - offsetX;
        const y = (event?.pageY || event?.touches?.[0]?.clientY) - offsetY;
        return {x, y};
    }

    touchStart = (event) => {
        // coment this out START for audio removal
        if (!this.isScratching) {
            this.audio = document.getElementById(this.elementId);
            this.audio.muted = false;
            if (!this.isPlaying) {
                this.audio.play().then().catch((err)=>{
                    console.log(err);
                });
            }
            if (this.props?.isMobile) {
                let userAgent = window.navigator.userAgent;
                if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                    this.audio.currentTime = 0;
                } else {
                    this.checkPlaying();
                }
            } else {
                this.audio.currentTime = 0;
            }
        }
        // coment this out END for audio removal
        this.isScratching = true;
        this.lastPoint = this.getPosition(event);
        this.ctx.globalCompositeOperation = 'destination-out';
    }

    checkPlaying = () => {
        if ((this.audio && (this.audio.currentTime !== this.audio.duration)) || (this.audio && this.audio.currentTime === 0)) {
            this.playing = true;
        } else {
            this.playing = false;
        }
    }

    touchMove = (event) => {
        const parentNode = document.getElementById('canvasContainer');
        const canvasChild = document.getElementById('scratchCanvas');
        const hasChild = parentNode.contains(canvasChild);
        // comment this out START for audio removal
        this.checkPlaying();
        if (event && this.isScratching) {
            if (hasChild && !this.playing) {
                this.audio = document.getElementById(this.elementId);
                this.audio.muted = false;
                this.audio.play().then().catch((err)=>{
                    console.log(err);
                });
            } else if (this.playing && !hasChild) {
                this.stopAudio();
            }
        } else {
            if (this.audio && this.playing) {
                this.stopAudio();
            }
        }
        // comment this out END
        if (!this.isScratching) return;
        event.preventDefault();
        const ctx = this.ctx;
        const a = this.lastPoint;
        const b = this.getPosition(event);
        const dist = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
        const angle = Math.atan2(b.x - a.x, b.y - a.y);
        const offsetX = this.brush.width / 2;
        const offsetY = this.brush.height / 2;
        for (let x, y, i = 0; i < dist; i++) {
            x = a.x + (Math.sin(angle) * i) - offsetX;
            y = a.y + (Math.cos(angle) * i) - offsetY;
            ctx.drawImage(this.brush, x, y);
        }

        this.lastPoint = b;
        this.handlePercentage(this.getFilledInPixels(32));
    }

    touchEnd = (event) => {
        this.isScratching = false;
        if (this.audio) {
            this.stopAudio();
        }
    }

    stopAudio = () => {
        if (this.isPlaying) {
            this.audio.pause();
        }
        this.audio.currentTime = 0;
    }

    getFilledInPixels = (stride) => {
        if (!stride || stride < 1) {
            stride = 1;
        }
        let pixels = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        let pdata = pixels.data;
        let l = pdata.length;
        let total = (l / stride);
        let count = 0;
        for (var i = count = 0; i < l; i += stride) {
            if (parseInt(pdata[i]) === 0) {
                count++;
            }
        }
        return Math.round((count / total) * 100);
    }

    getAverageRGB = () => {
        let data;
        let defaultRGB = {r:0,g:0,b:0};
        const blockSize = 5; 
        let i = -4;
        let length;
        let rgb = {r:0,g:0,b:0};
        let count = 0;
        try {
            data = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        } catch(e) {
            /* security error, img on diff domain */
            return defaultRGB;
        }
        length = data.data.length;
        while ( (i += blockSize * 4) < length ) {
            ++count;
            rgb.r += data.data[i];
            rgb.g += data.data[i+1];
            rgb.b += data.data[i+2];
        }
        // ~~ used to floor values
        rgb.r = ~~(rgb.r/count);
        rgb.g = ~~(rgb.g/count);
        rgb.b = ~~(rgb.b/count);
        // return this.rgbToHex(~~(rgb.r/count), ~~(rgb.g/count), ~~(rgb.b/count));
        return rgb;

    }     

    componentToHex = (c) => {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }
      
    rgbToHex = (r, g, b) => {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }

    handlePercentage = (filledInPixels) => {
        filledInPixels = filledInPixels || 0;
        let parentNode = document.getElementById('canvasContainer');
        let canvasChild = document.getElementById('scratchCanvas');
        if (filledInPixels > 45 && parentNode.contains(canvasChild)) {
            this.canvas.style.opacity = '0';
            setTimeout(() => { 
                if(parentNode.contains(canvasChild)) {
                    parentNode.removeChild(this.canvas);
                    this.setConf();
                }
            }, 500);
            return;
        }
    }

    setConf = () => {
        setTimeout(() => { 
            this.props.onUpdateStatus(1);
            this.setState({visible: false});
        }, 100);
    }

    render() {
        let width = this.state.width;
        if (this.props?.isMobile) {
            width = this.state.width;
        } 
        else {
            width = this.props.width > 430 ? 430 : this.props.width
        }
        let conf =  <Confetti colors={this.state.colors} className={!this.state.visible ? classes.FadeOut : ''} height={this.state.height} width={width}></Confetti>;
        return ( 
            <div style={
                {
                    position: 'relative',
                    width: width,
                    maxWidth: '430px',
                    height: '100%',
                    maxHeight: '932px',
                    top: 0
                }
            } id={'canvasContainer'}>
                <canvas className={classes.List} style={
                    {
                        position: 'absolute',
                        zIndex: 2000,
                        maxWidth: '430px',
                        width: '100%',
                        height: '100%',
                        maxHeight: '932px',
                        top: 0
                    }
                }
                ref={el => this.canvas = el}
                id={'scratchCanvas'} /> 
                <div className={
                        [
                            classes.Secret,
                            classes.Absolute,
                            classes.Fill,
                            classes.NoSelect,
                            classes.Flex,
                            classes.JustifyCenter,
                            classes.ItemsCenter
                        ].join()
                    }> 
                    {
                        this.isLoading ?
                        '' :
                        <div >{conf}{this.props.children}</div>} 
                </div> 
            </div>
        );
    }
}

export default Scratcher;